import { Button, Row, Table, InputGroup, FormControl, Col, Spinner } from "react-bootstrap";
import { GoSearch } from "react-icons/go"
import { BsPlusLg } from "react-icons/bs"
import { useState } from "react";
import AzioniPerVerificati from "./AzioniPerVerificati";
import AggiungiAdminModal from "./AggiungiAdminModal";

export default function GestioneAdmin({
    partecipanti,
    setShowToast,
    setMessaggioToast,
    setTitoloToast,
    setRicaricaPartecipanti,
    comId,
    impostazioni, 
    ricaricaPartecipanti,
    // AGGIUNGIAMO LE PROPS PER LA RICERCA PASSATE DAL PADRE
    searchTerm,
    setSearchTerm
}) {

    //Stato per gestire la visualizzazione del modale di aggiunta admin
    const [showAggiungiAdmin, setShowAggiungiAdmin] = useState(false)
    
    // RIMOSSO lo stato locale: const [ricercaAdmin, setRicercaAdmin] = useState("")

    return (
        <>
            {/*Contenitore principale della gestione admin */}
            <div className="container-sm p-0 p-md-4">
                {/*Sezione superiore con titolo, pulsante e barra di ricerca */}
                <Row className="d-flex justify-content-between mb-3">
                    <Col md={4} xs={12}>
                        <h4 className="w-auto"><strong>Admin registrati</strong></h4>
                    </Col>
                    <Col md={5} xs={12} className="text-md-end mb-2 mb-md-0">
                        {/* Pulsante per aprire il modale di aggiunta admin */}
                        <Button className="w-auto"
                            onClick={() => { setShowAggiungiAdmin(true) }}
                        >Aggiungi un admin <BsPlusLg className="m-auto" /></Button>
                    </Col>
                    <Col md={3} xs={12}>
                        {/* Barra di ricerca collegata al padre */}
                        <InputGroup>
                            <InputGroup.Text id="basic-addon1">
                                <GoSearch />
                            </InputGroup.Text>
                            <FormControl placeholder="Cerca nome, cognome, email..."
                                value={searchTerm} // <-- Usa il valore del padre
                                onChange={(ev) => { setSearchTerm(ev.target.value) }} // <-- Aggiorna lo stato nel padre
                            />
                        </InputGroup>
                    </Col>
                </Row>
                {/* Tabella con la lista degli amministratori */}
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Cognome</th>
                            <th>Nome</th>
                            <th>Codice Fiscale</th>
                            <th >Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ricaricaPartecipanti ? (
                                <tr>
                                    {/* Sistemato colSpan da 7 a 4 */}
                                    <td colSpan={4} style={{ textAlign: "center" }}>
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Caricamento...</span>
                                        </Spinner>
                                    </td>
                                </tr>
                            ) : partecipanti.length > 0 ? (
                                partecipanti
                                    // RIMOSSO IL .filter() LOCALE: IL BACKEND CI DA GIA' I DATI FILTRATI!
                                    .sort((a, b) => {
                                        // Ordinamento locale sui 10 elementi della pagina
                                        const cognomeA = a.datiPartecipante.dparCognome.toLowerCase();
                                        const cognomeB = b.datiPartecipante.dparCognome.toLowerCase();
                                        const nomeA = a.datiPartecipante.dparNome.toLowerCase();
                                        const nomeB = b.datiPartecipante.dparNome.toLowerCase();

                                        if (cognomeA < cognomeB) return -1;
                                        if (cognomeA > cognomeB) return 1;
                                        if (nomeA < nomeB) return -1;
                                        if (nomeA > nomeB) return 1;
                                        return 0;
                                    })
                                    .map((el, index) => (
                                        <tr key={index} className={el.parStato === 'bloccato' ? "row-blocked" : ''}>
                                            <td>{el.datiPartecipante.dparCognome}</td>
                                            <td>{el.datiPartecipante.dparNome}</td>
                                            <td>{el.datiPartecipante.dparCf}</td>
                                            <td>
                                                <AzioniPerVerificati partecipante={el}
                                                    setRicaricaPartecipanti={setRicaricaPartecipanti}
                                                    impostazioni={impostazioni} />
                                            </td>
                                        </tr>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="text-center py-4">
                                        Nessun amministratore trovato.
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </div>
            {/*Modale per aggiungere un nuovo admin */}
            <AggiungiAdminModal
                show={showAggiungiAdmin}
                setShow={setShowAggiungiAdmin}
                comId={comId}
                setShowToast={setShowToast}
                setMessaggioToast={setMessaggioToast}
                setTitoloToast={setTitoloToast}
                setRicaricaPartecipanti={setRicaricaPartecipanti} />
        </>
    )
}